<template>
    <div>
      <button @click="listarArchivos">Listar archivos de Dropbox</button>
      <ul>
        <li v-for="archivo in archivos" :key="archivo.id">
          {{ archivo.name }}
        </li>
      </ul>

      <div v-for="miniatura in miniaturas" >
        <img :src="'data:image/jepg;base64,' + miniatura.thumbnail" alt="Miniatura" />
      </div>
    </div>
  </template>
  
  <script>
  import {Dropbox} from 'dropbox'
  import axios from 'axios'
  export default {
    data() {
      return {
        archivos: [],
        miniaturas:[],
      };
    },
    methods: {
      listarArchivos() {
        const dbx = new Dropbox({
      
          accessToken: 'sl.Bf_aujR_gHiJDadGT5j07551L9Hmxl-QIRe6rOXKGoy6zLZgEmdwtj1rJi1MrYjBE9xSN9h6sW0FIFY8y4cOdy1egk3TKhk2yvw5T0YjwZtC8-mNgh3o26Q1YeZ-svonxTVPJC3h7Kg',
        });

        
        dbx.filesListFolder({ path: '' })
          .then(response => {
            this.archivos = response.result.entries
            console.log(response.result.entries)
          })
          .catch(error => {
            console.error(error);
          });
          

          dbx.filesGetThumbnailBatch({  
            entries: [{  
              path: '/photo_2018-01-31_12-20-35.jpg',  
              size: 'w128h128',  
              format: 'jpeg',  
            }]  
          })
          .then(response => {
            this.miniaturas = response.result.entries;
          })
          .catch(error => {
            console.error('Error al obtener miniaturas:', error); 
          });

      }//listarArchivos
    }//methods
  };
  </script>